module.exports = __webpack_public_path__ + "img/titan.0e3b5059.svg";